import "./amenities.css";
import {
  FaTree,
  FaBicycle,
  FaWater,
  FaTheaterMasks,
  FaChild,
  FaDumbbell,
  FaSpa,
  FaSwimmingPool,
  FaGolfBall,
  FaUsers,
  FaSkating,
  FaHome,
  FaCloud,
  FaUmbrellaBeach,
  FaSeedling,
  FaFireAlt
} from "react-icons/fa";

import { MdSelfImprovement } from "react-icons/md";
import { useState } from "react";
import Brochure from "../brochure/brochure";
import ContactPopup from "../contactPopup/contactPopup";

export default function Amenities() {

  const [showBrochure, setShowBrochure] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupPos, setPopupPos] = useState({ x: 0, y: 0 });

  // ✅ FIXED POPUP POSITION LOGIC
  const openPopup = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();

    setPopupPos({
      x: rect.left + rect.width / 2, // center align
      y: rect.bottom + window.scrollY + 10, // below button
    });

    setPopupOpen(true);
  };

  return (
    <section id="amenities" className="amenities">

      <div className="amenities-container">

        {/* HEADER */}
        <div className="amenities-header">
          <p>Amenities</p>
          <h2>World Class Lifestyle Experience</h2>

          <div className="brochure-wrapper">
            <button onClick={openPopup}>
              Get Quote
            </button>

            {showBrochure && (
              <Brochure onClose={() => setShowBrochure(false)} />
            )}
          </div>
        </div>

        {/* GROUND FLOOR */}
        <div className="amenity-block">
          <h3>GROUND FLOOR</h3>
          <ul>
            <li><FaTree /> Cascading Plantation</li>
            <li><FaBicycle /> Bicycle Loop</li>
            <li><FaWater /> Central Plaza with Interactive Fountain</li>
            <li><FaTheaterMasks /> Amphitheatre</li>
            <li><FaSeedling /> Eco rail with fruit-bearing trees</li>
            <li><MdSelfImprovement /> Meditation / Yoga Deck</li>
            <li><FaChild /> Kids Play Area</li>
            <li><FaDumbbell /> Rock Climbing Wall</li>
            <li><FaUsers /> Senior Citizen Garden Lounge</li>
            <li><FaDumbbell /> Multipurpose Court</li>
          </ul>
        </div>

        {/* PODIUM LEVEL */}
        <div className="amenity-block">
          <h3>PODIUM LEVEL</h3>
          <ul>
            <li><FaSeedling /> Aroma Garden court</li>
            <li><FaBicycle /> Board Walk</li>
            <li><FaTree /> Cascading Plantation</li>
            <li><FaGolfBall /> Golf Simulator</li>
            <li><FaSwimmingPool /> Infinity Pool</li>
            <li><FaSpa /> Steam N Sauna</li>
            <li><FaSpa /> Relaxation therapy room</li>
            <li><FaUsers /> Senior Citizen Reflex Walk</li>
            <li><FaSkating /> Skating Rink</li>
            <li><FaHome /> Club House</li>
          </ul>
        </div>

        {/* TERRACE LEVEL */}
        <div className="amenity-block">
          <h3>TERRACE LEVEL</h3>
          <ul>
            <li><FaUmbrellaBeach /> Events Lawn</li>
            <li><FaHome /> Hobby Station</li>
            <li><FaCloud /> Sunken Party Deck</li>
            <li><FaFireAlt /> Sky Bar</li>
            <li><MdSelfImprovement /> Sky Yoga Lawn</li>
            <li><FaWater /> Stargazing Deck</li>
            <li><FaSpa /> Solarium</li>
            <li><FaSeedling /> Urban Farming</li>
          </ul>
        </div>

      </div>

      {/* ✅ POPUP */}
      {popupOpen && (
        <ContactPopup
          open={popupOpen}
          position={popupPos}
          onClose={() => setPopupOpen(false)}
        />
      )}

    </section>
  );
}